<template>
    <UPagination
        v-model:page="uPage"
        :items-per-page="1"
        :total="props.lastPage"
        :sibling-count="1"
        show-edges
        color="secondary"
        class="mb-16"
        @click="setPage(uPage)"
    />
<!--
    <div
        v-if="pages.length"
        class="pagination"
    >
        <button
            v-for="(p, i) in pages"
            :key="p"
            :class="[{ bordered: p !== page, default: p === page }]"
            @click="setPage(p)"
        >
            {{ (pages.length > marginRight) && (i < pages.length) && (pages[i+1] > p + 1) ? '...' : p }}
        </button>
    </div>
-->
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    page: number
    lastPage: number
}>(), {
    page: 1,
    lastPage: 1,
});

const uPage = ref(props.page);
// const marginLeft = 6;
// const marginRight = 6;

const emit = defineEmits<{(e: 'update:page', value: number): void}>();

// const pages = computed(() => {
//     const out: number[] = [];
//
//     for (let i = 1; i <= props.lastPage; i += 1) {
//         if (
//             i === 1
//             || i === props.lastPage
//             || (i <= props.page && props.page - i <= marginLeft)
//             || (i >= props.page && i - props.page <= marginRight)
//         ) {
//             out.push(i);
//         }
//     }
//
//     return out.length === 1 ? [] : out;
// });

function setPage(p: number) {
    emit('update:page', p);
}
</script>
